import React, { useEffect, useState, useMemo } from 'react';
import { db } from './firebase';
import {  doc, getDoc, } from 'firebase/firestore';
import { useBusinessAuth } from '../context/BusinessContext';
import FormSupplierProfile from '../../FrontEnd/Integration/FormSupplierProfile';
import Spinner from '../../FrontEnd/Integration/Spinner';

export default function FbBusinessProfile() {
  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);

  const { user } = useBusinessAuth();

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        const snap =  doc(db , 'supplier',user.uid)
        const ref=await getDoc(snap)
         if (ref.exists()) {
          setProfile({ id: ref.id, ...ref.data() });
        }
        
      
       
      } catch (err) {
        console.error("Erro ao buscar pedidos:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);





  return (
  
    <div>
{loading && <Spinner/>}
  
      <FormSupplierProfile company={profile}/>
    </div>
     
  )
}